import { CUSTOMER_TYPES, PRODUCTS, REGIONS } from '@boltenergy-be/shared'
import dayjs from 'dayjs'
import { ProductPromo } from './types'
import { IS_PROD } from 'constants/envs'

// PLENTY PROMOS
export const PRODUCT_PROMOS = [
  {
    product: PRODUCTS.plentyVariableOnline,
    availableInRegion: [REGIONS.flanders],
    code: {
      [CUSTOMER_TYPES.residential]: 'PLENTY350AND230AND10MWHINJ',
      [CUSTOMER_TYPES.professional]: 'PLENTY450AND0AND10MWHINJ'
    },
    period: IS_PROD
      ? {
          start: dayjs('2026-09-01').startOf('day'),
          end: dayjs('2026-09-01').endOf('month')
        }
      : {
          // TODO: month earlier on non-prod environments for staging testing of new promo
          start: dayjs('2026-08-01').startOf('day'),
          end: dayjs('2026-08-01').endOf('month')
        }
  },
  {
    product: PRODUCTS.plentyFix,
    availableInRegion: [REGIONS.flanders],
    code: {
      [CUSTOMER_TYPES.residential]: 'PLENTY300AND0AND10MWHINJ',
      [CUSTOMER_TYPES.professional]: ''
    },
    period: {
      start: dayjs('2026-09-01').startOf('day'),
      end: dayjs('2026-09-01').endOf('month')
    }
  },
  {
    product: PRODUCTS.plentyVariableOnline,
    availableInRegion: [REGIONS.flanders],
    code: {
      [CUSTOMER_TYPES.residential]: 'PLENTY90MWHAND0AND10MWHINJ',
      [CUSTOMER_TYPES.professional]: 'PLENTY100MWHAND0AND10MWHINJ'
    },
    period: {
      start: dayjs(IS_PROD ? '2026-10-01' : '2026-09-01').startOf('day'), // TODO: change back to always 2026-10-01, only for staging testing now
      end: dayjs('2026-10-01').endOf('month')
    }
  }
] as const satisfies ProductPromo[]

export const PRODUCT_PROMO_CODES = new Set<string>(
  PRODUCT_PROMOS.map(({ code }) => [code[CUSTOMER_TYPES.professional], code[CUSTOMER_TYPES.residential]])
    .flat()
    .filter(Boolean)
)
